import $ from 'jquery';

/**
 * URL parser, parses query string in url
 * @param {String} urlString - query string from url. eg window.location.search
 * @return {Object} - parsed key, value pairs of query strings
 */
export const parseQuery = (urlString) => {
  // remove '?', '&'
  if (!urlString) {
    return {};
  }

  urlString = urlString.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
  const items = {};
  const splits = urlString.split('&');
  const length = splits.length;
  let v;
  let name;
  let value;

  for (let i = 0; i < length; i++) {
    v = splits[i].split('=');
    name = decodeURIComponent(v.shift());
    value = v.length ? decodeURIComponent(v.join('=')).replace(/\+/g, ' ') : null;

    if (typeof items[name] === 'string') {
      items[name] = [items[name]];
      items[name].push(value);
    } else if (typeof items[name] === 'object') {
      items[name].push(value);
    } else {
      items[name] = value;
    }
  }
  return items;
};

// ability to extract get params
// Ex: /plan?promo=abc url produces {promo: abc} object
export const queryString = () => parseQuery(window.location.search);

// redirect to params
// Ex: if params = {a: 'b', c: [1,2]}, redirect to ?a=b&c=1&c=2
export const redirectWithParams = (params) => {
  if (Object.keys(params).length > 0 && $.param(params).length > 0) {
    window.location.href = '?' + $.param(params);
  } else {
    window.location.href = window.location.pathname;
  }
};
